<form #form="ngForm">

    <app-group-box title="AS2 connection details" [required]="true" [isValid]="isValid" [disabled]="disabled()" [supportsEdit]="true" (editClicked)="editTransport(value())">
        <div class="details-content">
            <p class="endpoint-owner-note">{{customerNote()}}</p>
            <div class="property-grid">
                <p class="property-name">Host name:</p>
                <p class="property-value">{{customerHostname()}}</p>
                <p class="property-name">AS2 ID:</p>
                <p class="property-value">{{customerAS2Id()}}</p>
                <p class="property-name">Public certificate:</p>
                <p class="property-value">{{customerPublicCert()}}</p>
            </div>

            <div class="partner-fields">
                <p class="endpoint-owner-note">{{partnerNote()}}</p>
                @for (field of partnerFields() ?? []; track $index)
                {
                    <ul>
                        <li>{{field.Description}}</li>
                    </ul>
                }
            </div>
        </div>
    </app-group-box>

</form>